
import IconNotificationInfo from '@/components/icons/icon-notification-info.svg'
import { StatisticGraphicsEcoScore } from '@/generated-clients/bff'
import { EcoScoreRecommendation, GetTrip, SmartConnectDataScore } from '@/generated-clients/myTrips'
import CircleIcon from '@components/shared/icons/CircleIcon.vue'
import EcoScoreSectionItem from '@components/shared/section/EcoScoreSectionItem.vue'
import { LoadState } from '@util/types'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const TriplogModule = namespace('Triplog');

@Component({
  name: 'EcoScoreSection',
  components: {
    IconNotificationInfo,
    EcoScoreSectionItem,
    CircleIcon
  }
})
export default class EcoScoreSection extends Vue {
  @Prop()
  private ecoScore: StatisticGraphicsEcoScore | SmartConnectDataScore;

  @Prop({ required: false })
  private trip: GetTrip | undefined;

  @TriplogModule.Action('fetchEcoScoreRecommendation')
  private fetchEcoScoreRecommendation;

  @TriplogModule.Getter('getEcoScoreRecommendationStatus')
  private ecoScoreRecommendationStatus: LoadState;

  @TriplogModule.Getter('getEcoScoreRecommendation')
  private ecoScoreRecommendation: EcoScoreRecommendation | undefined;

  private circumference = 2 * Math.PI * 90;

  private scorePortion = this.circumference * 0.25;

  private ecoScoreRecommendationForTrip = -1;

  mounted() {
    this.loadEcoScoreRecommendation();
  }

  @Watch('ecoScore')
  private loadEcoScoreRecommendation() {
    if (this.trip && this.ecoScore && this.trip.id != this.ecoScoreRecommendationForTrip) {
      this.ecoScoreRecommendationForTrip = this.trip.id;
      this.fetchEcoScoreRecommendation({ tripId: this.trip.id });
    }
  }

  get ecoScoreRecommendationLoaded() {
    return this.ecoScoreRecommendationStatus === LoadState.Success;
  }

  get accelerationSize() {
    return this.scorePortion * this.ecoScore.accelerationScore / 100.0;
  }

  get brakingSize() {
    return this.scorePortion * this.ecoScore.brakingScore / 100.0;
  }

  get speedingSize() {
    return this.scorePortion * this.ecoScore.speedingScore / 100.0;
  }

  get idlingSize() {
    return this.scorePortion * this.ecoScore.idlingScore / 100.0;
  }

  get brakingOffset() {
    return this.accelerationSize;
  }

  get speedingOffset() {
    return this.brakingOffset + this.brakingSize;
  }

  get idlingOffset() {
    return this.speedingOffset + this.speedingSize;
  }

  get centerEcoScore() {
    return this.ecoScore.totalEcoScore >= 10 ? 44.38 : 74.38;
  }
}
